import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Redirect } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/modal.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";

const Rs = "&#8377;";

const MdlStaffIdCardSettings = ({
  sample_id,
  color_option_id,
  actionClose,
  actionDone,
  file_url,
}) => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [mSampleSettings, setSampleSettings] = useState([]);
  const [mSampleDesignSettings, setSampleDesignSettings] = useState([]);
  const [mSampleDataSettings, setSampleDataSettings] = useState([]);

  const [originalSampleSettings, setOriginalSampleSettings] = useState([]);
  const [font_master, setFont_master] = useState([]);

  const [FILE_URL, setFILE_URL] = useState(file_url);
  const [showPreview, setShowPreview] = useState(true);
  const [iframeKey, setIframeKey] = useState(Date.now());
  const [height, setHeight] = useState("300px");
  const iframeRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoggedIn(false);
    }

    getIdCardSettings();

    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const getIdCardSettings = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const API_NAME = "getStaffIdCardSampleSettings.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      API_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      sample_id: sample_id,
      color_option_id: color_option_id,
    };
    const queryString = new URLSearchParams(params).toString();
    console.log("Full URL: ", `${URL}${queryString}`);

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const filteredSettings = response.data.Sample_Design_Settings.filter(
            (item) => item.show_settings === "1"
          );
          setSampleSettings(response.data.Sample_Settings);
          setSampleDataSettings(response.data.SampleDataSettings);
          setSampleDesignSettings(filteredSettings);
          setOriginalSampleSettings(
            JSON.parse(JSON.stringify(filteredSettings))
          );
          //setFont_master(response.data.font_master);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  };

  const HandleClose = () => {
    setShow(false);
    actionClose();
  };

  const HandleSubmit = () => {
    setShow(false);
    actionClose();
    // TODO: Submit logic here
  };
  const handleRefreshDialog = () => {
    getIdCardSettings();
  };
  const handleRefresh = () => {
    setShowPreview(true); // Show loader
    setIframeKey(Date.now()); // Force iframe reload by changing `key`
  };

  const handleAttrChange = (settingIndex, attrIndex, value) => {
    const updatedSettings = [...mSampleDesignSettings];
    updatedSettings[settingIndex].attribute[attrIndex].attribute_value = value;
    setSampleDesignSettings(updatedSettings);
  };

  const applySettingChange = () => {
    const changedSettings = getModifiedSettings();
    // alert(JSON.stringify(changedSettings));

    if (changedSettings.length === 0) {
      myToast.notify_info("No changes detected.");
      return;
    }

    setLoading(true);

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const mStaffData = SessionManager.getStaffDetails();
    const STAFF_ID = mStaffData.staff_id;
    const mSession = SessionManager.getCurrentSession();
    const SESSION_ID = mSession[0].session_id;

    const API_NAME = "AddPrintableSampleSettings.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      API_NAME;

    const params = new URLSearchParams();
    params.append("staff_id", STAFF_ID);
    params.append("school_code", SCHOOL_CODE);
    params.append("sample_id", sample_id);
    params.append("color_option_id", color_option_id);
    params.append("session_id", SESSION_ID);
    params.append("sample_settings", JSON.stringify(changedSettings));

    axios
      .post(URL, params)
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          handleRefresh();
          setOriginalSampleSettings(
            JSON.parse(JSON.stringify(mSampleDesignSettings))
          );
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  };

  const getModifiedSettings = () => {
    const modified = [];

    mSampleDesignSettings.forEach((currentSetting, sIdx) => {
      const originalSetting = originalSampleSettings[sIdx];

      const changedAttributes = currentSetting.attribute.filter(
        (attr, aIdx) => {
          return (
            attr.attribute_value !==
            originalSetting?.attribute[aIdx]?.attribute_value
          );
        }
      );

      if (changedAttributes.length > 0) {
        modified.push({
          ...currentSetting,
          attribute: changedAttributes,
        });
      }
    });

    return modified;
  };

  const handleToggle = async (index) => {
    setLoading(true);
    const newData = [...mSampleDataSettings];
    const item = newData[index];
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    var mStaffData = SessionManager.getStaffDetails();
    var STAFF_ID = mStaffData.staff_id;
    const API_NAME = "updatePrintableSampleDataSettingsStaff.php";

    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      API_NAME;

    const params = {
      sample_id: item.sample_id,
      option_id: item.option_id,
      field_options: item.field_options,
      school_code: SCHOOL_CODE,
      staff_id: STAFF_ID,
    };

    const queryString = new URLSearchParams(params).toString();
    console.log("Calling: ", `${URL}?${queryString}`);

    try {
      const response = await axios.get(URL, { params });
      const resData = response.data;
      setLoading(false);

      if (resData.api_status === "OK") {
        // Toggle the value locally
        newData[index].default_status = item.default_status === "1" ? "0" : "1";
        setSampleDataSettings(newData);
        myToast.notify_success("Updated Succdessfully");
        handleRefresh();
      } else {
        myToast.notify_warning("Failed to update setting");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating setting:", error);
      myToast.notify_error("Something went wrong.");
    }
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div>
      <Modal
        show={show}
        onHide={HandleClose}
        animation={false}
        className="fullscreen-modal hide-scrollbar"
        dialogClassName="fullscreen-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Sample Settings And Design Customization</Modal.Title>

          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <Button
              className="margin_0 gravity_center"
              variant="outline-secondary"
              onClick={HandleClose}
              style={{ fontSize: "2rem", height: "30px" }}
              title="Close"
            >
              &times;
            </Button>
            <Button
              className="margin_0 gravity_center"
              variant="outline-secondary"
              onClick={handleRefreshDialog}
              style={{ fontSize: "1.5rem", height: "30px" }}
              title="Refresh"
            >
              🔄
            </Button>
            <Button
              style={{ fontSize: "1rem", height: "30px" }}
              className="margin_0 "
              variant="outline-secondary"
              size="sm"
              onClick={() => HandleSubmit()}
            >
              Done
            </Button>
            <Button
              style={{ fontSize: "1rem", height: "30px" }}
              className="margin_0"
              variant="outline-secondary"
              size="sm"
              onClick={() => applySettingChange()}
            >
              Apply
            </Button>
          </div>
        </Modal.Header>

        <Modal.Body className="hide-scrollbar">
          {Loading && (
            <div>
              <MyLoader />
            </div>
          )}
          <div className="row settings-scroll">
            <div className="col-md-5 col-sm-5 padding_0 ">
              <div className="gravity_center">
                <h3>Preview</h3>
              </div>
              <div style={{ position: "relative", width: "100%" }}>
                {/* Overlay Loader */}
                {showPreview && (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.6)",
                      zIndex: 10,
                    }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}

                {/* Iframe */}
                <Iframe
                  key={iframeKey}
                  ref={iframeRef}
                  src={FILE_URL}
                  width="100%"
                  height={height}
                  style={{ border: "none", overflow: "hidden" }}
                  id="iFrame1"
                  scrolling="no"
                  onLoad={() => setShowPreview(false)}
                />
              </div>
              <div className="gravity_center" style={{ marginTop: "20px" }}>
                <h3>Data Selection</h3>
              </div>

              <div
                className="row bg_card_primary_outline"
                style={{ margin: "2px 10px", padding: "5px" }}
              >
                {mSampleDataSettings &&
                  mSampleDataSettings.map((item, index) => (
                    <div key={index} className="col-md-4 padding_0">
                      <div
                        className={
                          item.default_status === "1"
                            ? "bg_card_green_outline margin_5 padding_5"
                            : "bg_card_grey_outline margin_5 padding_5"
                        }
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fw-bold">{item.field_options}</span>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`switch-${index}`}
                              checked={item.default_status === "1"}
                              onChange={() => handleToggle(index)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="col-md-7 col-sm-7 padding_0">
              <div className="">
                {mSampleDesignSettings &&
                  mSampleDesignSettings.map((setting, sIdx) => (
                    <div
                      key={sIdx}
                      className=" bg_card_primary_outline shadow-sm"
                      style={{ marginBottom: "3px" }}
                    >
                      <div
                        className="bg_card_primary text-white d-flex justify-content-between align-items-center"
                        style={{
                          height: "35px",
                          fontSize: "16px",
                          padding: "0 10px",
                        }}
                      >
                        <div>
                          <strong>{setting.setting_name}</strong>
                        </div>
                      </div>

                      <div className="card-body padding_10">
                        <div className="row">
                          {/* Editable Attributes */}

                          {setting.attribute &&
                            setting.attribute.map((attr, aIdx) => {
                              let options = null;
                              try {
                                if (attr.data_set) {
                                  options = Array.isArray(attr.data_set)
                                    ? attr.data_set
                                    : JSON.parse(attr.data_set);
                                }
                              } catch (e) {
                                console.error(
                                  "Invalid data_set JSON:",
                                  attr.data_set
                                );
                              }

                              // Check if value is a valid hex color code
                              const isHexColor =
                                typeof attr.attribute_value === "string" &&
                                /^#([0-9A-F]{3}){1,2}$/i.test(
                                  attr.attribute_value
                                );

                              return (
                                <div className="col-md-2 padding_2" key={aIdx}>
                                  <div className="mb-2">
                                    <label className="form-label">
                                      {attr.attribute_name}
                                    </label>

                                    {options ? (
                                      <select
                                        className="form-select"
                                        value={attr.attribute_value}
                                        onChange={(e) =>
                                          handleAttrChange(
                                            sIdx,
                                            aIdx,
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="">-- Select --</option>
                                        {options.map((option, i) => (
                                          <option key={i} value={option}>
                                            {option}
                                          </option>
                                        ))}
                                      </select>
                                    ) : isHexColor ? (
                                      <div className="d-flex align-items-center gap-1">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={attr.attribute_value}
                                          onChange={(e) =>
                                            handleAttrChange(
                                              sIdx,
                                              aIdx,
                                              e.target.value
                                            )
                                          }
                                        />
                                        <input
                                          type="color"
                                          className="form-control form-control-color "
                                          value={attr.attribute_value}
                                          onChange={(e) =>
                                            handleAttrChange(
                                              sIdx,
                                              aIdx,
                                              e.target.value
                                            )
                                          }
                                          style={{
                                            width: "50px",
                                            height: "32px",
                                            padding: "1px",
                                            border: "1px solid #ced4da",
                                            borderRadius: "4px",
                                            background: "none",
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={attr.attribute_value}
                                        onChange={(e) =>
                                          handleAttrChange(
                                            sIdx,
                                            aIdx,
                                            e.target.value
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MdlStaffIdCardSettings;
